// GENERATED by scripts/sync-kit-css.mjs from agenta-app.css — do not edit by hand.
/** The kit stylesheet as a string, ready for a <style> tag in the app document. */
export const KIT_CSS = `/* Agenta app kit. Colour only via --ag-* (KIT_TOKENS); no remote assets, imports or font faces. */
:root {
    --ag-shadow:
        0 1px 2px light-dark(color-mix(in srgb, var(--ag-fg) 8%, transparent), transparent),
        0 1px 6px -1px light-dark(color-mix(in srgb, var(--ag-fg) 5%, transparent), transparent);
    --ag-hover: color-mix(in srgb, var(--ag-fg) 5%, transparent);
    --ag-press: color-mix(in srgb, var(--ag-fg) 10%, transparent);
    --ag-well: color-mix(in srgb, var(--ag-fg) 4%, transparent);
}
*,
*::before,
*::after {
    box-sizing: border-box;
}
html {
    height: 100%;
    font-size: 12px;
}
body {
    margin: 0;
    min-height: 100%;
    font: 12px/1.45 var(--ag-font);
    background: var(--ag-bg);
    color: var(--ag-fg);
    -webkit-font-smoothing: antialiased;
}
h1,
h2,
h3,
p {
    margin: 0 0 0.5em;
}
h1 {
    font-size: 16px;
    font-weight: 600;
}
h2 {
    font-size: 13px;
    font-weight: 600;
}
h3 {
    font-size: 12px;
    font-weight: 600;
}
a {
    color: var(--ag-accent);
    text-decoration: underline;
}
small,
.ag-muted {
    color: var(--ag-muted);
}
button,
input,
select,
textarea {
    font: inherit;
    color: inherit;
}
[hidden] {
    display: none !important;
}
[aria-busy="true"] {
    opacity: 0.7;
    pointer-events: none;
}

/* Layout */
.ag-app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 12px 16px;
}
/* The toolbar and columns stay full width: cancel the page padding around them. */
.ag-app > .ag-toolbar {
    margin: -12px -16px 12px;
}
.ag-app > .ag-columns {
    margin: 0 -16px -12px;
}
.ag-app > .ag-toolbar + .ag-columns {
    margin-top: -12px;
}
.ag-toolbar {
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: var(--ag-bg);
    border-bottom: 1px solid var(--ag-line);
}
.ag-toolbar h1 {
    margin: 0 auto 0 0;
}
.ag-columns {
    display: flex;
    flex: 1;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    overflow-x: auto;
}
.ag-column {
    display: flex;
    flex: 1 1 240px;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
    padding: 8px;
    background: var(--ag-well);
    border-radius: var(--ag-radius);
}
.ag-column > h2 {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0 0 2px;
    padding: 0 2px;
}
.ag-column[data-over] {
    outline: 2px dashed var(--ag-accent);
    outline-offset: -2px;
}
.ag-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin: 0;
    padding: 0;
    list-style: none;
}
.ag-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 8px;
    font-variant-numeric: tabular-nums;
}
@media (max-width: 480px) {
    .ag-columns {
        flex-direction: column;
        align-items: stretch;
        overflow-x: visible;
    }
    .ag-column {
        flex-basis: auto;
    }
}

/* Controls */
.ag-btn,
.ag-input,
.ag-select {
    height: 28px;
    padding: 0 10px;
    border: 1px solid var(--ag-line);
    border-radius: var(--ag-radius);
    background: var(--ag-bg);
    color: var(--ag-fg);
}
.ag-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
}
.ag-btn:hover {
    background: var(--ag-hover);
}
.ag-btn:active {
    background: var(--ag-press);
}
.ag-btn-primary,
.ag-btn-primary:hover,
.ag-btn-primary:active {
    background: var(--ag-accent);
    border-color: var(--ag-accent);
    color: var(--ag-bg);
}
.ag-btn-primary:hover {
    background: color-mix(in srgb, var(--ag-accent) 85%, var(--ag-bg));
}
.ag-btn-primary:active {
    background: color-mix(in srgb, var(--ag-accent) 75%, var(--ag-bg));
}
.ag-input,
.ag-select {
    padding: 0 8px;
    min-width: 0;
}
.ag-input::placeholder {
    color: var(--ag-muted);
}
textarea.ag-input {
    height: auto;
    min-height: 56px;
    padding: 6px 8px;
    resize: vertical;
}
.ag-check {
    position: relative;
    appearance: none;
    width: 14px;
    height: 14px;
    margin: 0 4px 0 0;
    border: 1px solid var(--ag-line);
    border-radius: 3px;
    background: var(--ag-bg);
    vertical-align: -2px;
    cursor: pointer;
}
.ag-check:checked {
    background: var(--ag-accent);
    border-color: var(--ag-accent);
}
.ag-check:checked::after {
    content: "";
    position: absolute;
    left: 4px;
    top: 1px;
    width: 3px;
    height: 7px;
    border: solid var(--ag-bg);
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}
.ag-btn:focus-visible,
.ag-input:focus-visible,
.ag-select:focus-visible,
.ag-check:focus-visible,
.ag-card:focus-visible {
    outline: 2px solid var(--ag-accent);
    outline-offset: 1px;
}
.ag-btn:disabled,
.ag-input:disabled,
.ag-select:disabled,
.ag-check:disabled,
[aria-disabled="true"] {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Surfaces */
.ag-card {
    padding: 8px 10px;
    border: 1px solid var(--ag-line);
    border-radius: var(--ag-radius);
    background: var(--ag-bg);
    box-shadow: var(--ag-shadow);
    transition:
        transform 0.12s ease,
        opacity 0.12s ease,
        box-shadow 0.12s ease;
}
.ag-card[draggable="true"] {
    cursor: grab;
}
.ag-card[data-dragging] {
    opacity: 0.65;
    transform: scale(0.98);
    box-shadow: none;
    cursor: grabbing;
}
.ag-badge {
    display: inline-flex;
    align-items: center;
    height: 18px;
    padding: 0 6px;
    border-radius: 999px;
    background: var(--ag-accent-soft);
    color: var(--ag-fg);
    font-size: 11px;
    font-weight: 500;
    line-height: 1;
    white-space: nowrap;
}
/* Tone text leans 25% toward --ag-fg so it keeps 4.5:1 on its own tint in both themes. */
.ag-badge[data-tone="ok"] {
    color: color-mix(in srgb, var(--ag-ok) 75%, var(--ag-fg));
    background: color-mix(in srgb, var(--ag-ok) 10%, transparent);
}
.ag-badge[data-tone="warn"] {
    color: color-mix(in srgb, var(--ag-warn) 75%, var(--ag-fg));
    background: color-mix(in srgb, var(--ag-warn) 12%, transparent);
}
.ag-badge[data-tone="crit"] {
    color: color-mix(in srgb, var(--ag-crit) 75%, var(--ag-fg));
    background: color-mix(in srgb, var(--ag-crit) 10%, transparent);
}
.ag-empty {
    padding: 24px 12px;
    border: 1px dashed var(--ag-line);
    border-radius: var(--ag-radius);
    color: var(--ag-muted);
    text-align: center;
}
.ag-toast {
    position: fixed;
    right: 12px;
    bottom: 12px;
    z-index: 100;
    max-width: min(320px, calc(100vw - 24px));
    padding: 8px 12px;
    border-radius: var(--ag-radius);
    background: var(--ag-fg);
    color: var(--ag-bg);
    box-shadow: 0 6px 16px color-mix(in srgb, var(--ag-fg) 20%, transparent);
    animation: ag-toast-in 0.16s ease-out;
}
.ag-toast[data-fade] {
    animation:
        ag-toast-in 0.16s ease-out,
        ag-toast-out 0.3s ease-in 3s forwards;
}
@keyframes ag-toast-in {
    from {
        opacity: 0;
        transform: translateY(6px);
    }
}
@keyframes ag-toast-out {
    to {
        opacity: 0;
        visibility: hidden;
    }
}
@media (prefers-reduced-motion: reduce) {
    .ag-card,
    .ag-toast {
        transition: none;
        animation: none;
    }
    .ag-toast[data-fade] {
        animation: ag-toast-out 1ms linear 3s forwards;
    }
}
`
